module.exports = "<vue-component component=\"Navbar\" class=\"navbarWrapper\" permanent></vue-component>\n"